import PaymentMethod from './PaymentMethod';

import $Form from '../../common/forms';
import { AdyenCheckout, ApplePay } from '@adyen/adyen-web';

export default class AdyenApplePayPaymentMethod extends PaymentMethod {
  constructor(option, form, paymentPage) {
    super(option, form, paymentPage);

    this.sessionId = $('meta[name=AdyenTokenizeSessionId]').attr('content');
    this.sessionData = $('meta[name=AdyenTokenizeSessionData]').attr('content');
    this.clientKey = $('meta[name=AdyenClientKey]').attr('content');
    this.environment = $('meta[name=AdyenEnvironment]').attr('content');
  }

  get applePayConfiguration() {
    return {
      buttonType: 'book',
      totalPriceLabel: 'Quote total amount',
      amount: {
        currency: 'GBP',
        value: 0,
      },
      totalPriceStatus: 'pending',
    };
  }

  get checkoutConfiguration() {
    return {
      session: {
        id: this.sessionId,
        sessionData: this.sessionData,
      },
      environment: this.environment,
      locale: 'en-US',
      countryCode: 'GB',
      clientKey: this.clientKey,
      onPaymentCompleted: this.onPaymentCompleted.bind(this),
      onPaymentFailed: this.onPaymentFailed.bind(this),
      onError: this.onError.bind(this),
      showPayButton: false,
    };
  }

  onPaymentCompleted(result, component) {
    fetch('/events/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event: 'adyen_apple_pay_payment_completed',
        data: { result: result.resultCode },
      }),
    });

    $Form.postAjax(this.form, this.form.find('input[type=submit]'));
  }

  onPaymentFailed(result, component) {
    $Form.showGeneralError(this.form, 'adyen-apple-pay', 'Payment failed. If the problem persists, contact support.');
    component.setStatus('ready');

    fetch('/events/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event: 'adyen_apple_pay_payment_failed',
        data: { result: result },
      }),
    });
  }

  onError(error, component) {
    component.setStatus('ready');

    if (error.cause.type === 'cancel') return;

    $Form.showGeneralError(this.form, 'adyen-apple-pay', 'An error occurred. If the problem persists, contact support.');

    fetch('/events/log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event: 'adyen_apple_pay_payment_error',
        data: { error: error },
      }),
    });
  }

  async isAvailable() {
    if (!this.isIosDevice()) {
      return false;
    }

    const checkout = await AdyenCheckout(this.checkoutConfiguration);

    const ApplePayConstructor = window.__TEST_APPLE_PAY__ ?? ApplePay;
    this.applePayComponent = new ApplePayConstructor(checkout, this.applePayConfiguration);

    return new Promise((resolve) => {
      this.applePayComponent
        .isAvailable()
        .then(() => {
          this.applePayComponent.mount('#applepay-container');
          resolve(true);
        })
        .catch((e) => {
          //Apple Pay is not available
          console.log('Apple Pay is not available', e);
          resolve(false);
        });
    });
  }

  onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    this.applePayComponent.submit();
  }

  isIosDevice() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
  }
}
